import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { KiddeeChat } from "@/components/KiddeeChat";
import { InstallPrompt } from "@/components/InstallPrompt";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { RefCapture } from "@/components/RefCapture";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import GuidePage from "@/pages/GuidePage";
import CollabPage from "@/pages/CollabPage";
import CreatorStatsPage from "@/pages/CreatorStatsPage";
import AdminPage from "@/pages/AdminPage";
import TrackPage from "@/pages/TrackPage";
import PoliciesPage from "@/pages/PoliciesPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ReviewPage from "@/pages/ReviewPage";
import AuthCallback from "@/pages/AuthCallback";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentPages";
import { AccountPage, FavoritesPage } from "@/pages/AccountPages";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/product/:slug" element={<ProductPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/guide" element={<GuidePage />} />
      <Route path="/collab" element={<CollabPage />} />
      <Route path="/collab/stats" element={<CreatorStatsPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/track" element={<TrackPage />} />
      <Route path="/policies" element={<PoliciesPage />} />
      <Route path="/blog" element={<BlogPage />} />
      <Route path="/blog/:slug" element={<BlogPostPage />} />
      <Route path="/review/:orderId" element={<ReviewPage />} />
      <Route path="/account" element={<AccountPage />} />
      <Route path="/orders" element={<AccountPage />} />
      <Route path="/favorites" element={<FavoritesPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App min-h-screen flex flex-col overflow-x-hidden">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <FavoritesProvider>
              <ScrollToTop />
              <RefCapture />
              <Navbar />
              <div className="flex-1">
                <AppRoutes />
              </div>
              <Footer />
              <KiddeeChat />
              <InstallPrompt />
              <Toaster position={window.innerWidth < 768 ? "top-center" : "bottom-center"} />
            </FavoritesProvider>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
